/**
 * A page-level error that replaces the launch spinner and shows a banner.
 *
 * All fields are i18n keys, and stay unresolved until the banner renders -
 * resolving them here would run before the i18n bundle finishes loading. Text
 * that is already resolved also works, since `translate` passes unknown
 * strings through unchanged.
 *
 * `title` is rendered twice - as the banner heading and as the page headline -
 * so the two can never drift apart.
 *
 * `body` is the sentence below the heading. It owns the spacing around its
 * optional `{{ reason }}` placeholder, so each locale controls its own
 * separator, and it has to stay a key: the pipe that renders it cannot supply
 * interpolation params for an already-resolved string.
 *
 * `reason` is the optional sentence spliced into that placeholder, ending at
 * its final period.
 */
export interface PersistentError {
  title: string;
  body: string;
  reason?: string;
}

export const LAUNCH_FAILED: PersistentError = {
  title: 'Error.Persistent.LaunchFailed.Title',
  body: 'Error.Persistent.LaunchFailed.Body',
};

export const COVERAGE_CHECK_FAILED: PersistentError = {
  title: 'Error.Persistent.CoverageCheckFailed.Title',
  body: 'Error.Persistent.CoverageCheckFailed.Body',
};
